module.exports = __webpack_public_path__ + "media/images/app-store-005ad2c4d17fd2dd8bc8ed36d92c1f65.png";